import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const greyLight = ui.neutral[300];
const grey = ui.neutral[500];

export const elementaryLabelCss = {
  color: greyLight,
};

export const classroomWrapperCss = {
  display: "flex",
  justifyContent: "space-between",
};

export const anchorCss = {
  color: "inherit",
  padding: "0",
};

export const noClassroomWrapperCss = {
  color: grey,
  padding: "8px 16px",
};

export const disabledCss = {
  color: "#959595",
  "&:hover": {
    color: "#959595",
  },
};
